<app-loading-dialog></app-loading-dialog>
<div class="row no-margin p-0">
  <div class="col-12 no-margin p-0 header-sticky">
    <app-header [isLoggedIn]="showHead"></app-header>
  </div>
  <div class="col-12 app-content p-2">
    <router-outlet></router-outlet>
  </div>
</div>
